/* eslint-disable no-undef */
class FacetFiltersForm extends HTMLElement {
  constructor () {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    const facetForm = this.querySelector('form')
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop')
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape)

    const applyFiltersBtn = this.querySelector('.button-apply-filters')
    if (applyFiltersBtn) {
      applyFiltersBtn.addEventListener('click', this.onApplyBtnClick.bind(this))
    }

    FacetFiltersForm.setSliders()
    FacetFiltersForm.setTagRemove('.subscription-toggle', '.remove-Subscription')
    FacetFiltersForm.setTagRemove('.prescription-toggle', '.remove-Prescription')
    FacetFiltersForm.checkTagFilter('.subscription-toggle', 'Subscription')
    FacetFiltersForm.checkTagFilter('.prescription-toggle', 'Prescription')
    this.customSortDropdown()
  }

  customSortDropdown () {
    const dropdownHeader = document.querySelector('.custom-dropdown-header')
    const dropdownList = document.querySelector('.custom-dropdown')
    const dropdownSelected = document.querySelector('#sortingSelected')
    const dropdownArrow = document.querySelector('.custom-dropdown-header svg')

    dropdownHeader.addEventListener('click', function (event) {
      event.stopImmediatePropagation()
      event.stopPropagation()
      event.preventDefault()
      dropdownList.classList.toggle('hide')
    })

    document.addEventListener('click', function (event) {
      if (
        !dropdownList.contains(event.target) &&
        !dropdownHeader.contains(event.target) &&
        !dropdownSelected.contains(event.target) &&
        !dropdownArrow.contains(event.target)
      ) {
        dropdownList.classList.add('hide')
      }
    })

    FacetFiltersForm.setCustomDropdownEvent()
  }

  static setCustomDropdownEvent () {
    const selectElement = document.getElementById('SortBy')
    const customDropdown = document.querySelector('.custom-dropdown')
    const customDropdownOptions = customDropdown.querySelectorAll('.custom-dropdown-item')
    const customDropdownSelected = document.querySelector('#sortingSelected')

    customDropdownOptions.forEach((option) => {
      option.removeEventListener('click', () => { })
      option.addEventListener('click', () => {
        const selectedValue = option.getAttribute('data-value')
        const selectedCompletevalue = option.getAttribute('data-value-complete')

        selectElement.value = selectedValue
        customDropdownSelected.innerHTML = selectedCompletevalue

        const event = new Event('input', {
          bubbles: true,
          cancelable: true
        })
        selectElement.dispatchEvent(event)
        customDropdown.classList.add('hide')
      })
    })
  }

  static checkTagFilter (toggleEl, tagControl) {
    const urlParams = new URLSearchParams(window.location.search)
    const tagFilters = urlParams.getAll('filter.p.tag')
    const togglesButton = document.querySelectorAll(toggleEl)

    if (tagFilters.includes(tagControl)) {
      togglesButton.forEach((toggleButton) => {
        toggleButton.checked = true
      })
    }
  }

  static setTagRemove (toggleEl, removeEl) {
    const togglesButton = document.querySelectorAll(toggleEl)
    togglesButton.forEach((toggleButton) => {
      toggleButton.addEventListener('change', function () {
        if (!toggleButton.checked) {
          document.querySelector(removeEl).click()
        }
      })
    })
  }

  static setSliders () {
    const fromSlider = document.querySelector('#fromSlider')
    const toSlider = document.querySelector('#toSlider')
    const fromInput = document.querySelector('#Filter-Price-GTE')
    const spanFrom = document.querySelector('.lowest-price')
    const toInput = document.querySelector('#Filter-Price-LTE')
    const minPriceSelected = document.querySelector('#min-price-selected')
    const spanTo = document.querySelector('.highest-price')
    const maxPriceSelected = document.querySelector('#max-price-selected')

    const mobileFromSlider = document.querySelector('#mobileFromSlider')
    const mobileToSlider = document.querySelector('#mobileToSlider')
    const mobileFromInput = document.querySelector('#Mobile-Filter-Price-GTE')
    const mobileSpanFrom = document.querySelector('.mobile-lowest-price')
    const mobileToInput = document.querySelector('#Mobile-Filter-Price-LTE')
    const mobileSpanTo = document.querySelector('.mobile-highest-price')

    FacetFiltersForm.fillSlider(fromSlider, toSlider, '#B3FFE3', '#65DEB1', toSlider)
    FacetFiltersForm.fillSlider(mobileFromSlider, mobileToSlider, '#B3FFE3', '#65DEB1', mobileToSlider)
    FacetFiltersForm.setToggleAccessible(toSlider)
    FacetFiltersForm.setToggleAccessibleMobile(mobileToSlider)

    fromSlider.oninput = () => FacetFiltersForm.controlFromSlider(fromSlider, toSlider, fromInput, spanFrom, minPriceSelected)
    toSlider.oninput = () => FacetFiltersForm.controlToSlider(fromSlider, toSlider, toInput, spanTo, maxPriceSelected)

    mobileFromSlider.oninput = () => FacetFiltersForm.controlFromSlider(mobileFromSlider, mobileToSlider, mobileFromInput, mobileSpanFrom, minPriceSelected)
    mobileToSlider.oninput = () => FacetFiltersForm.controlToSlider(mobileFromSlider, mobileToSlider, mobileToInput, mobileSpanTo, maxPriceSelected)
  }

  static setListeners () {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets (disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  static renderPage (searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById('ProductCount')
    const countContainerDesktop = document.getElementById('ProductCountDesktop')
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading')

    if (countContainer) {
      countContainer.classList.add('loading')
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading')
    }

    sections.forEach((section) => {
      let url = null
      if (section !== undefined) {
        url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      } else {
        url = `${window.location.pathname}?${searchParams}`
      }
      const filterDataUrl = element => element.url === url
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch (url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.setSliders()
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.setCustomDropdownEvent()
        /* FacetFiltersForm.renderProductCount(html); */
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML)
      })
  }

  static renderSectionFromCache (filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    // FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML)
  }

  static renderProductGridContainer (html) {
    if (new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer') != null) { document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML }
    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel')
      })
  }

  static renderProductCount (html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount')
    const containerDesktop = document.getElementById('ProductCountDesktop')
    container.innerHTML = count
    container.classList.remove('loading')
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove('loading')
    }
  }

  /*   static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  } */

  static renderFilters (html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    )
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    )

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove()
      }
    })

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined
      return jsFilter ? element.id === jsFilter.id : false
    }

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element))
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId)

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id)
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1]
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender)
            return
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender)
        }
      }
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'))
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID))

        const newFacetDetailsElement = document.getElementById(closestJSFilterID)
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? '.mobile-facets__close-button'
          : '.facets__summary'
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector)

        const isTextInput = event.target.getAttribute('type') === 'text'

        if (newElementToActivate && !isTextInput) newElementToActivate.focus()
      }
    }
  }

  static renderActiveFacets (html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop']

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements (html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting']

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML
    })

    if (document.getElementById('FacetFiltersFormMobile') != null) {
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents()
    }
  }

  /*   static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  } */

  static renderCounts (source, target) {
    const targetSummary = target.querySelector('.facets__summary')
    const sourceSummary = source.querySelector('.facets__summary')

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML
    }

    const targetHeaderElement = target.querySelector('.facets__header')
    const sourceHeaderElement = source.querySelector('.facets__header')

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML
    }

    const targetWrapElement = target.querySelector('.facets-wrap')
    const sourceWrapElement = source.querySelector('.facets-wrap')

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'))
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'))
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML
    }
  }

  static renderMobileCounts (source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list')
    const sourceFacetsList = source.querySelector('.mobile-facets__list')

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML
    }
  }

  static updateURLHash (searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
  }

  static getSections () {
    const productGrid = document.getElementById('product-grid')
    if (productGrid) {
      return [
        {
          section: productGrid.dataset.id
        }
      ]
    } else {
      const currentURL = window.location.href
      const baseUrl = currentURL.split('?')[0]
      window.location.href = baseUrl
      return []
    }
  }

  static controlFromInput (fromSlider, fromInput, toInput, controlSlider, spanFrom, minPriceSelected) {
    const [from, to] = FacetFiltersForm.getParsed(fromInput, toInput)
    FacetFiltersForm.fillSlider(fromInput, toInput, '#B3FFE3', '#65DEB1', controlSlider)
    if (from > to) {
      fromSlider.value = to
      fromInput.value = to
      spanFrom.innerHTML = '$' + to
      minPriceSelected.innerHTML = '$' + to
    } else {
      fromSlider.value = from
      spanFrom.innerHTML = '$' + from
      minPriceSelected.innerHTML = '$' + from
    }
    spanFrom.style.color = '#157A55'
  }

  static controlToInput (toSlider, fromInput, toInput, controlSlider, spanTo, maxPriceSelected) {
    const [from, to] = FacetFiltersForm.getParsed(fromInput, toInput)
    FacetFiltersForm.fillSlider(fromInput, toInput, '#B3FFE3', '#65DEB1', controlSlider)
    FacetFiltersForm.setToggleAccessible(toInput)
    if (from <= to) {
      toSlider.value = to
      toInput.value = to
      spanTo.innerHTML = '$' + to
      maxPriceSelected.innerHTML = '$' + to
    } else {
      toInput.value = from
      spanTo.innerHTML = '$' + from
      maxPriceSelected.innerHTML = '$' + from
    }
    spanTo.style.color = '#157A55'
  }

  static controlFromSlider (fromSlider, toSlider, fromInput, spanFrom, minPriceSelected = null) {
    const [from, to] = FacetFiltersForm.getParsed(fromSlider, toSlider)
    FacetFiltersForm.fillSlider(fromSlider, toSlider, '#B3FFE3', '#65DEB1', toSlider)
    if (from > to) {
      fromSlider.value = to
      fromInput.value = to
      spanFrom.innerHTML = '$' + to
      if (minPriceSelected != null) {
        minPriceSelected.innerHTML = '$' + to
      }
    } else {
      fromInput.value = from
      spanFrom.innerHTML = '$' + from
      if (minPriceSelected != null) {
        minPriceSelected.innerHTML = '$' + from
      }
    }
    spanFrom.style.color = '#157A55'
  }

  static controlToSlider (fromSlider, toSlider, toInput, spanTo, maxPriceSelected = null) {
    const [from, to] = FacetFiltersForm.getParsed(fromSlider, toSlider)
    FacetFiltersForm.fillSlider(fromSlider, toSlider, '#B3FFE3', '#65DEB1', toSlider)
    FacetFiltersForm.setToggleAccessible(toSlider)
    if (from <= to) {
      toSlider.value = to
      toInput.value = to
      spanTo.innerHTML = '$' + to
      if (maxPriceSelected != null) {
        maxPriceSelected.innerHTML = '$' + to
      }
    } else {
      toInput.value = from
      toSlider.value = from
      spanTo.innerHTML = '$' + from
      if (maxPriceSelected != null) {
        maxPriceSelected.innerHTML = '$' + from
      }
    }
    spanTo.style.color = '#157A55'
  }

  static getParsed (currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10)
    const to = parseInt(currentTo.value, 10)
    return [from, to]
  }

  static fillSlider (from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to.max - to.min
    const fromPosition = from.value - to.min
    const toPosition = to.value - to.min
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`
  }

  static setToggleAccessible (currentTarget) {
    const toSlider = document.querySelector('#toSlider')
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2
    } else {
      toSlider.style.zIndex = 0
    }
  }

  static setToggleAccessibleMobile (currentTarget) {
    const toSlider = document.querySelector('#mobileToSlider')
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2
    } else {
      toSlider.style.zIndex = 0
    }
  }

  createSearchParams (form) {
    const formData = new FormData(form)
    return new URLSearchParams(formData).toString()
  }

  onSubmitForm (searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  onApplyBtnClick (event) {
    event.preventDefault()
    const searchParams = this.createSearchParams(event.target.closest('form'))
    this.onSubmitForm(searchParams, event)
  }

  onSubmitHandler (event) {
    event.preventDefault()
    const sortFilterForms = document.querySelectorAll('facet-filters-form form')
    if (!(event.srcElement.className === 'mobile-facets__checkbox')) {
      // const searchParams = this.createSearchParams(event.target.closest('form'))
      // this.onSubmitForm(searchParams, event)
      // } else {
      const forms = []
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile'

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list')
            noJsElements.forEach((el) => el.remove())
            forms.push(this.createSearchParams(form))
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form))
        }
      })

      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick (event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url = event.currentTarget.href.indexOf('?') === -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1)
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
  constructor () {
    super()
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)))
    this.setMinAndMaxValues()
  }

  onRangeChange (event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  setMinAndMaxValues () {
    const inputs = this.querySelectorAll('input')
    const minInput = inputs[0]
    const maxInput = inputs[1]
    if (maxInput.value) minInput.setAttribute('max', maxInput.value)
    if (minInput.value) maxInput.setAttribute('min', minInput.value)
    if (minInput.value === '') maxInput.setAttribute('min', 0)
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'))
  }

  adjustToValidValues (input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
  constructor () {
    super()
    const facetLink = this.querySelector('a')
    facetLink.setAttribute('role', 'button')
    facetLink.addEventListener('click', this.closeFilter.bind(this))
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event)
    })

    const removeAllLinks = document.querySelectorAll('.remove-all-filters')
    const removeSubscription = document.querySelector('.remove-Subscription')
    const removePrescription = document.querySelector('.remove-Prescription')
    if (removeSubscription) {
      const subscriptionToggles = document.querySelectorAll('.subscription-toggle')
      removeSubscription.addEventListener('click', function () {
        subscriptionToggles.forEach((toggle) => {
          toggle.checked = false
        })
      })
    }
    if (removePrescription) {
      const prescriptionToggles = document.querySelectorAll('.prescription-toggle')
      removePrescription.addEventListener('click', function () {
        prescriptionToggles.forEach((toggle) => {
          toggle.checked = false
        })
      })
    }
    removeAllLinks.forEach((link) => {
      link.addEventListener('click', this.setFalseTagsFilters)
    })
  }

  setFalseTagsFilters () {
    const tagToggles = document.querySelectorAll('.tags-toggle')
    tagToggles.forEach((toggle) => {
      toggle.checked = false
    })
  }

  closeFilter (event) {
    event.preventDefault()
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form')
    form.onActiveFilterClick(event)
  }
}

customElements.define('facet-remove', FacetRemove)
